import ChefBlog from './ChefBlog'

export default ChefBlog



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/containers/ChefBlog/index.js